"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Report_1 = __importDefault(require("@mui/icons-material/Report"));
var inertia_1 = require("@inertiajs/inertia");
var react_i18next_1 = require("react-i18next");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var ReactAdminError = function (_a) {
    var error = _a.error, resourceName = _a.resourceName, resourceURL = _a.resourceURL;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var resource = (0, react_admin_1.useResourceDefinitions)();
    var logger = q_play_core_1.logManager.getLogger();
    if (!resourceName || !resourceURL) {
        var keys = Object.keys(resource);
        if (keys.length === 0) {
            logger.error("No keys found in the resource object");
            return React.createElement(React.Fragment, null);
        }
        else {
            resourceName = resourceName || keys[0];
            resourceURL = resourceURL || resource[keys[0]].name;
        }
    }
    var clearRaStoreFromLocalStorage = function () {
        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);
            if (key.startsWith("RaStore") && (key.includes(resourceName) || key === "RaStore.version")) {
                localStorage.removeItem(key);
            }
        }
    };
    var handleGoBackClick = function () {
        clearRaStoreFromLocalStorage();
        var currentUrl = window.location.href;
        if (resourceURL) {
            inertia_1.Inertia.visit(currentUrl);
        }
        else {
            logger.warn("No resource URL to navigate to");
        }
    };
    return (React.createElement("div", { style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
            textAlign: "center",
        } },
        React.createElement("h1", { style: {
                fontFamily: "Geomanist-Bold",
                fontSize: "26px",
                color: "var(--info-color)",
            } },
            React.createElement(Report_1.default, null),
            t("Something went wrong")),
        React.createElement("div", null, t("An error occurred and your request could not be completed")),
        process.env.APP_ENV !== "production" && error && (React.createElement("details", { style: { marginTop: "15px" } },
            React.createElement("summary", null, t("Details")),
            React.createElement("h2", { style: {
                    fontFamily: "Geomanist",
                    fontSize: "16px",
                    color: "var(--info-color)",
                } }, t(error.toString())))),
        React.createElement("div", { style: { marginTop: "15px" } },
            React.createElement(q_play_components_1.Button, { variant: "primary", onClick: handleGoBackClick }, t("Go back")))));
};
exports.default = ReactAdminError;
